
import React from 'react'
import {
    fetchStart,
    fetchFail,
    fetchApplyData,
    fetchTesekkurData,
    fetchOneriTalepData,
    fetchSikayetData,
    fetchFeedBackData,
    fetchEnd,

} from '../features/feedbackSlice'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { toastInfoNotify, toastSuccessNotify, toastErrorNotify, toastWarnNotify } from '../helper/ToastNotify'
// import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref as dbRef, uploadBytes, getDownloadURL, getMetadata, listAll, list, deleteObject } from "firebase/storage";
import { db } from "../db/firebase_db"
import { getDatabase, onValue, ref, remove, set, update } from "firebase/database";
import { uid } from "uid";
import { useState } from 'react';
import { useNavigate } from "react-router-dom"
import package_json from "../../package.json"
import { getDeviceInfo } from '../helper/telemetryService'
import { resolveMailRouteForTopic } from '../helper/mailRoutesCache'
// E-posta doğrulaması formlarla aynı merkezi kurallardan gelir (DRY).
import { normalizeEmail, validateEmail } from '../helper/contactValidation'

const normalizeMailValue = (value) => String(value ?? "").trim()

const escapeMailHtml = (value) => normalizeMailValue(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")


const useFeedbackCall = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()


    function formatDate(dateStr) {
        const parts = dateStr.split(' ')[0].split('-')
        return `${parts[2]}-${parts[1]}-${parts[0]}`
    }

    //! firebase data gönder
    const postFireData2 = async (address, info) => {

        dispatch(fetchStart())

        try {

            const uID = uid()
            const db = getDatabase();

            // Detaylı cihaz bilgisini otomatik topla
            const deviceInfo = await getDeviceInfo()

            // Eğer konu 'Etiklik' ve document var ise Firestore'a da ekle
            if (info?.topic === "Etiklik" && info?.document) {

                const store = getStorage() //storage bilgisini çek

                const filePath = `images/${info?.document?.name}`;
                const fileRef = dbRef(store, filePath);

                // Dosyayı Firebase Storage'a yükleyin
                await uploadBytes(fileRef, info?.document);

                // Yüklenen dosyanın URL'sini alın
                const downloadURL = await getDownloadURL(fileRef);

                if (downloadURL) {

                    // info objesini ayıkla ve downloadURL bilgisini yeni obje bilgisi içerisine ekle
                    // + cihaz bilgilerini ekle
                    const newData = { ...info, imgUrl: downloadURL, ...deviceInfo }

                    //! realtime db kaydı için fonksiyon çalıştır
                    set(ref(db, `${address}/` + uID), newData);

                }
                else {
                    toastWarnNotify('Beklenmeyen bir hata oluştu. Tekrar deneyiniz.')
                }
            }
            else {

                // Cihaz bilgilerini form datası ve birlikte kaydet
                const newData = { ...info, ...deviceInfo }
                set(ref(db, `${address}/` + uID), newData);
            }


            toastSuccessNotify('Talebiniz alınmıştır teşekkür ederiz.')
            navigate('/')

            await sendMail(info)

        } catch (error) {
            console.log("error:  ", error)
            toastErrorNotify('❌ İşem başarısız, lütfen tekrar deneyiniz.')
        }

    }


    const postFireData = async (address, info) => {
        dispatch(fetchStart());

        try {
            const uID = uid();
            const db = getDatabase();

            // ✅ Detaylı cihaz bilgilerini otomatik topla (tüm 14 alan)
            const deviceInfo = await getDeviceInfo()

            // Form datası + cihaz bilgilerini birleştir
            let newData = { ...info, ...deviceInfo };

            if (info?.topic === "Etiklik" && info?.document) {
                const store = getStorage();
                const filePath = `images/${uID}_${info.document.name}`;
                const fileRef = dbRef(store, filePath);

                // Yükleme ve URL alma
                await uploadBytes(fileRef, info.document);
                const downloadURL = await getDownloadURL(fileRef);

                newData.imgUrl = downloadURL;
            }

            // Realtime Database'e kayıt (cihaz bilgileri de dahil)
            await set(ref(db, `${address}/` + uID), newData);

            toastSuccessNotify('Talebiniz alınmıştır, teşekkür ederiz.');
            navigate('/');

            // Mail gönderimi
            await sendMail(newData);

        } catch (error) {
            console.log("error:", error);
            toastErrorNotify('❌ İşlem başarısız, lütfen tekrar deneyiniz.');
        }
        finally{
            dispatch(fetchEnd())
        }
    }


    const getFireData = async (address, dateFrom, dateTo) => {

        dispatch(fetchStart())

        try {

            const db = getDatabase();
            const starCountRef = ref(db, `${address}/`);
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val();

                if (data == null || data == undefined) {

                    dispatch(fetchFeedBackData({}))
                }
                else {

                    //db den gelen datayı array olarak çevir
                    const dizi = Object.keys(data).map(key => { return { id: key, ...data[key] } })

                    if (dateFrom && dateTo) {

                        const result = dizi.filter((item) => {
                            return formatDate(item.datetime) >= dateFrom && formatDate(item.datetime) <= dateTo
                        })

                        dispatch(fetchFeedBackData(result))
                    }
                    else {
                        dispatch(fetchFeedBackData(data))
                    }

                }


            });

        } catch (error) {
            toastErrorNotify('No Get Data')
        }



    }


    const putFireData = async (address, info) => {


        try {

            const db = getDatabase()
            await update(ref(db, `${address}/${info.id}`), info)
            toastSuccessNotify('Updated Data')
            return true

        } catch (error) {
            console.log("putFireData_Sikayet :", error)
            toastErrorNotify('Aksiyon kaydedilemedi.')
            return false
        }
    }


    //! firebase data silme
    const removeFirebaseData = async (address, id) => {

        try {
            const db = getDatabase();
            remove(ref(db, `${address}/${id}`))
            toastSuccessNotify('Data Deleted ✅')
        } catch (error) {
            toastErrorNotify('No Delete Data ❌')
        }
    }


    const sendMail = async (info) => {

        const normalizeValue = (value) => {
            if (value === null || value === undefined) return "";
            if (typeof value === "string") return value.trim();
            return value;
        }

        const isFilled = (value) => {
            const normalized = normalizeValue(value);
            return normalized !== "";
        }

        const escapeHtml = (value) => {
            const text = String(value);
            return text
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/\"/g, "&quot;")
                .replace(/'/g, "&#39;");
        }

        const toMailSafeAscii = (value) => {
            const text = String(value);
            const charMap = {
                "ç": "c", "Ç": "C",
                "ğ": "g", "Ğ": "G",
                "ı": "i", "İ": "I",
                "ö": "o", "Ö": "O",
                "ş": "s", "Ş": "S",
                "ü": "u", "Ü": "U",
            };

            return text.replace(/[çÇğĞıİöÖşŞüÜ]/g, (char) => charMap[char] || char);
        }

        const encodeMailText = (value) => {
            return escapeHtml(toMailSafeAscii(value));
        }

        const buildMailMessage = (payload) => {
            const lines = [];
            const topic = normalizeValue(payload?.topic);
            const fullName = `${normalizeValue(payload?.name)} ${normalizeValue(payload?.surname)}`.trim();

            const addLine = (label, value) => {
                const normalized = normalizeValue(value);
                if (isFilled(normalized)) {
                    lines.push(`<div><b>${encodeMailText(label)}:</b> ${encodeMailText(normalized)}</div>`);
                }
            }

            addLine("Konu", topic);
            addLine("Alt Konu", payload?.topicDetail);
            addLine("Tarih", payload?.datetime);
            addLine("Ad Soyad", fullName);
            addLine("Telefon", payload?.phone);
            addLine("E-posta", payload?.email);
            addLine("Lokasyon", payload?.location);

            if (topic === "Etiklik") {
                addLine("Etik Kategori", payload?.title);
                addLine("Alt Başlık", payload?.subTitle);
            }

            if (topic === "Tehlikeli Durum & Ramak Kala") {
                addLine("Olay Tipi", payload?.eventType);
                addLine("Yeri / Zamanı", payload?.yerZaman);
                addLine("Detay", payload?.ramakkaladetay);
                addLine("İyileştirme Önerisi", payload?.oneri);
            }
            else {
                addLine("Detay", payload?.detail);
            }

            if (topic === "Talep" || topic === "Oneri Talep" || topic === "Öneri Talep" || topic === "Öneri & Talep") {
                addLine("Öneri Konusu", payload?.oneriler);
                addLine("Katkı Konusu", payload?.katkiKonusu);
            }

            return `<div>${lines.join("")}</div>`;
        }

        let address = ""
        let ccAddress = ""
        const mailContent = buildMailMessage(info)

        const route = resolveMailRouteForTopic(info?.topic)
        if (route.to?.length) {
            address = route.to.join(', ')
        }
        if (route.cc?.length) {
            ccAddress = route.cc.join(', ')
        }

        try {

            const data = JSON.stringify({
                "to": address ? address : `${process.env.REACT_APP_MAIL_TO_ADDRESS}`,
                "cc": ccAddress,
                "subject": `${package_json?.name} Bilgilendirme`,
                "message": mailContent || `<div><b>${encodeMailText("Konu")}:</b> ${encodeMailText(info?.topic || "")}</div>`,
                "digitalplatform": package_json?.name || "Bonna Feedback",
            })

            const option = {
                method: "post",
                url: `${process.env.REACT_APP_MAIL_ENDPOINT}/api/sendmail`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            }

            const res = await axios(option)

            if (res.status === 200) {
                console.log(" 📨 mail bilgilendirme yapılmıştır. 📨")
            }
            else {
                console.log(" ❌ mail gönderilemedi. ❌")
            }

        }
        catch (error) {
            console.log("sendMail Error: ", error)
        }
    }

    const sendActionMail = async (info) => {
        const recipient = normalizeEmail(info?.email)

        // Anonim (e-postasız) kayıt: aksiyon kaydedildi ama bildirim gönderilecek adres yok.
        if (recipient === "") {
            toastWarnNotify('Anonim kayıt: Bilgilendirme maili gönderilmedi.')
            return false
        }

        if (!validateEmail(recipient).isValid) {
            toastWarnNotify('Aksiyon kaydedildi; geçerli bir e-posta adresi olmadığı için bilgilendirme maili gönderilemedi.')
            return false
        }

        const reportTypeLabels = {
            sikayet: "Şikayet",
            oneriTalep: "Talep",
            tesekkur: "Teşekkür",
            ramakkala: "Tehlikeli Durum & Ramak Kala",
            etiklik: "Etik Bildirim"
        }

        const fullName = `${normalizeMailValue(info?.name)} ${normalizeMailValue(info?.surname)}`.trim()
        const reportType = reportTypeLabels[info?.type] || normalizeMailValue(info?.topic) || "Geri Bildirim"
        const lines = []

        const addLine = (label, value) => {
            const normalized = normalizeMailValue(value)
            if (normalized) {
                lines.push(`<div><b>${escapeMailHtml(label)}:</b> ${escapeMailHtml(normalized)}</div>`)
            }
        }

        addLine("Talep Türü", reportType)
        addLine("Ad Soyad", fullName)
        addLine("Kayıt Tarihi", info?.datetime)
        addLine("Konu", info?.topic)
        addLine("Etik Kategori", info?.title)
        addLine("Alt Başlık", info?.subTitle)
        addLine("Olay Tipi", info?.eventType)
        addLine("Yeri / Zamanı", info?.yerZaman)
        addLine("Talep Detayı", info?.detail || info?.ramakkaladetay)
        addLine("Aksiyon Tipi", info?.actionType)
        addLine("Aksiyon Açıklaması", info?.actionResult)

        const data = JSON.stringify({
            to: recipient,
            cc: "",
            subject: `${package_json?.name || "Bonna Feedback"} Aksiyon Bilgilendirmesi`,
            message: `<div><p>Talebinizle ilgili aksiyon bilgisi güncellenmiştir.</p>${lines.join("")}</div>`,
            digitalplatform: package_json?.name || "Bonna Feedback",
        })

        try {
            const res = await axios({
                method: "post",
                url: `${process.env.REACT_APP_MAIL_ENDPOINT}/api/sendmail`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data
            })

            if (res.status === 200) {
                toastInfoNotify('Aksiyon bilgilendirme maili gönderildi.')
                return true
            }

            throw new Error(`Mail endpoint status: ${res.status}`)
        } catch (error) {
            console.log("sendActionMail Error: ", error)
            toastErrorNotify('Aksiyon kaydedildi ancak bilgilendirme maili gönderilemedi.')
            return false
        }
    }

    return {

        getFireData,
        postFireData,
        // getFireData_Tesekkur,
        removeFirebaseData,
        // getFireData_OneriTalep,
        // getFireData_Sikayet,
        putFireData,
        sendActionMail

    }

}

export default useFeedbackCall




















